// extracted by mini-css-extract-plugin
module.exports = {"component":"filter-bar-component--1XkJl"};